import React, { useState } from 'react'
import { MARKER_DICTS, loadMarkerDict, saveMarkerDict } from './arucoRuntime'
import styles from './Vision.module.css'
import { Info } from "lucide-react";
// Sidebar for play-mode ArUco detection.
// The selected marker type must match the type used
// when the printed marker was generated.
const MarkerOptions = () => {
  const [dict, setDict] = useState(loadMarkerDict)
  const [showInfo, setShowInfo] = useState(false)

  const onChange = (e) => {
    const value = e.target.value
    saveMarkerDict(value)
    setDict(value)
  }

  return (
    <div className={styles.trackOptions}>
      <div className={styles.trackOptToggleRow}>
        <span className={styles.trackOptLabel}>
          Marker type
        </span>

        <select
          className={styles.trackOptSelect}
          value={dict}
          onChange={onChange}
        >
          {MARKER_DICTS.map((d) => (
            <option key={d.key} value={d.key}>
              {d.label}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.trackLineHint}>
        <span>
          Match this to the type used when creating your marker.
          {' '}
          <button
            type="button"
            onClick={() => setShowInfo((value) => !value)}
            className={styles.trackInfoButton}
            aria-expanded={showInfo}
            aria-label="More information about ArUco markers"
          >
            <Info size={12} />
          </button>
        </span>

        <span className={styles.trackHintWarning}>
          Wrong type may cause incorrect marker IDs.
        </span>
      </div>

      {showInfo && (
        <div className={styles.trackInfo}>
          <div className={styles.trackInfoTitle}>
            ArUco marker
          </div>

          <div className={styles.trackInfoText}>
            A printed square code that the camera uses to identify
            and track an object.
          </div>

          <div className={styles.trackInfoImportant}>
            <strong>Important:</strong> The selected type must match
            the type used when the marker was created.
          </div>

          <a
            href="https://chev.me/arucogen/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.trackInfoLink}
          >
            Create an ArUco marker ↗
          </a>
        </div>
      )}
    </div>
  )
}

export default MarkerOptions
